/**
 * This is the variant badges controller made for the product variant badges updates.
 *
 * The reason this is separated is because natunos mobile view does not share the glozin implementation of VariantRadiosDetail component hence we cannot reuse the component methods and functionality.
 * Coding both for component and natunos snippet will cause too much redundancy and syncing issues when an update occur.
 * @returns
 */
var VariantController = (function () {
  function renderBuyActions() {
    const buySectionElement = document.querySelector(
      '.product-detail__buy-buttons',
    );
    if (buySectionElement) {
      buySectionElement.classList.remove('hidden');

      // enable add to cart button
      const addToCartButton = buySectionElement.querySelector(
        'button[type="submit"]',
      );
      const buyButtonWrapper = buySectionElement.querySelector(
        '.btn-checkout-dynamic.btn-buy-now-injected-natuno',
      );

      if (addToCartButton) {
        addToCartButton.querySelector('.btn-label').textContent = 'Add to Cart';
        addToCartButton.removeAttribute('disabled');
      }
      if (buyButtonWrapper) {
        buyButtonWrapper.style = 'pointer-events:auto; opacity: 1;';

        const buyButtonInjected = buyButtonWrapper.querySelector(
          'button[data-natuno-buy-now-bound="true"]',
        );

        if (buyButtonInjected) {
          buyButtonInjected.removeAttribute('disabled');
        }
      }
    }

    // mobile view
    const addToCartWrapper = document.querySelector('#nsb-add_to_cart');
    const buyButtonWrapper = document.querySelector('#nsb-buy_now');
    if (addToCartWrapper) {
      const addToCartButton = addToCartWrapper.querySelector(
        'button[type="submit"]',
      );
      if (addToCartButton) {
        addToCartButton.removeAttribute('disabled');
        addToCartButton.querySelector('.btn-label').textContent = 'Add to Cart';
      }
    }

    if (buyButtonWrapper) {
      buyButtonWrapper.style = 'pointer-events: auto; opacity: 1;';
      buyButtonWrapper.classList.remove('disabled');
    }
  }

  function toggleStickySideFabVisibility(visible = true) {
    const sidefab = document.querySelector('.natuno-side-fab');
    const isMobile = isMobileDevice();
    if (sidefab && isMobile) {
      if (visible) {
        sidefab.classList.remove('hidden-important');
      } else {
        sidefab.classList.add('hidden-important');
      }
    }
  }

  function checkActionElementRendering() {
    // check if mobile
    const _isMobile = isMobileDevice();

    if (_isMobile) {
      // show actions but disable the buttons
      const actionEls = document.querySelectorAll(
        '.product-detail__buy-buttons',
      );

      actionEls.forEach((el) => {
        el.classList.remove('hidden');
      });
    }
  }

  function toSGTEpoch(dateInput) {
    return new Date(
      new Date(dateInput).toLocaleString('en-US', {
        timeZone: 'Asia/Singapore',
      }),
    ).getTime();
  }

  function renderMemberExclusiveActions() {
    // show member exclusive alert element
    const memberExclusiveAlert = document.querySelector(
      '.member-exclusive-alert',
    );

    if (memberExclusiveAlert) {
      memberExclusiveAlert.classList.remove('hidden');
    }

    // update actions buttons
    const productInfoEl = document.querySelector(
      '.product-detail__buy-buttons',
    );

    if (productInfoEl) {
      productInfoEl.classList.remove('hidden');
      const addCartBtn = productInfoEl.querySelector(
        '.btn-add-to-cart-injected-natuno',
      );
      const buyNowBtn = productInfoEl.querySelector(
        '.btn-buy-now-injected-natuno',
      );
      const loginBtn = productInfoEl.querySelector('.login-btn-action');
      const signupBtn = productInfoEl.querySelector('.signup-btn-action');

      // hide add to cart
      if (addCartBtn) {
        addCartBtn.classList.add('hidden');
      }
      // hide buy now
      if (buyNowBtn) {
        buyNowBtn.classList.add('hidden');
      }
      // display login button
      if (loginBtn) {
        loginBtn.classList.remove('hidden');
      }
      // display signup button
      if (signupBtn) {
        signupBtn.classList.remove('hidden');
      }
    }
  }

  return {
    createCustomBadge: function (
      { name, textColor, backgroundColor, customClass = '' },
      variant = false,
    ) {
      const badgeEl = document.createElement('div');
      badgeEl.classList.add(
        'product__badges-custom',
        'product__badges-inner',
        'align-self-start',
        'px-10',
        'py-5',
        'inline-flex',
        'content-center',
        'subheading_weight',
        'text-center',
        'lh-normal',
        customClass,
      );
      // add variant className if variant parameter is `true`
      if (variant) {
        badgeEl.classList.add('variant__badges-custom');
      }

      badgeEl.style = `--badges-color: ${textColor};--badges-bg: ${backgroundColor};`;
      badgeEl.textContent = name;
      return badgeEl;
    },
    getVariantMetafield: function ({ variantId, productId }) {
      const variantMetafield = document.querySelector(
        `#variant-metafields-${productId}`,
      );

      if (variantMetafield) {
        const jsonText = variantMetafield.textContent;

        const parsedJSON = JSON.parse(jsonText);

        const exact = parsedJSON.find((variant) => variant.id === variantId);

        return exact;
      }
      return null;
    },
    clearVariantBadges: function (productTarget) {
      const variantBadges = productTarget.querySelectorAll(
        '.variant__badges-custom',
      );

      variantBadges.forEach((badges) => badges.remove());
    },
    renderVariantBadges: function ({
      variantId,
      productTarget,
      productId,
      variantData,
    }) {
      let variantStatuses = {
        isComingSoon: false,
        isNewColorWay: false,
        isNew: false,
        disabledCartAction: false,
        memberExclusive: false,
        badges: [],
        variantAvailable: false,
      };

      const metafield = this.getVariantMetafield({ variantId, productId });
      const isAvailable = this.isColorOptionAvailable(variantId, variantData);
      const badgeWrapperEl = productTarget.querySelectorAll('.product__badges');

      // variant availability state
      variantStatuses.variantAvailable = isAvailable;

      // updates the variant statuses for referencing to other badges
      function updateVariantStatuses(badge, disabledCartAction = false) {
        const badgeNameLower = badge.name.toLowerCase();
        if (
          badgeNameLower === 'coming soon' ||
          badgeNameLower.includes('coming soon')
        ) {
          variantStatuses.isComingSoon = true;
        } else if (badgeNameLower === 'new') {
          variantStatuses.isNew = true;
        } else if (
          badgeNameLower === 'new colorway' ||
          badgeNameLower.includes('new colorway') ||
          badgeNameLower === 'new colorway' ||
          badgeNameLower.includes('new colorway')
        ) {
          variantStatuses.isNewColorWay = true;
        }
      }
      if (metafield && metafield.badges.length > 0) {
        let filteredBadges = [];
        if (isAvailable) {
          filteredBadges = metafield.badges.filter(
            (badge) => badge.name.toLowerCase() !== 'out of stock',
          );
        } else {
          filteredBadges = metafield.badges;
        }
        variantStatuses.badges = filteredBadges;

        badgeWrapperEl.forEach((wrapper) => {
          filteredBadges.forEach((badge) => {
            // update variant statuses
            updateVariantStatuses(badge, metafield.disableCartAction);

            // create the variant badges
            const customBadge = this.createCustomBadge(
              {
                backgroundColor: badge.background_color,
                name: badge.name,
                textColor: badge.text_color,
              },
              true,
            );

            wrapper.appendChild(customBadge);
          });
        });
      }

      if (metafield) {
        // update disabledCartAction status
        variantStatuses.disabledCartAction =
          metafield.disableCartAction || false;
        variantStatuses.memberExclusive = metafield.memberExclusive;
      }
      return variantStatuses;
    },
    isColorOptionAvailable(variantId, variantData = []) {
      const variant = variantData.find((variant) => variant.id === variantId);

      if (variant) {
        const similarColorVariants = variantData.filter(
          (_variant) => _variant.option1 === variant.option1,
        );

        return similarColorVariants.some(
          (colorVariant) => colorVariant.available,
        );
      }

      return false;
    },
    observeExclusiveAccess: function ({
      startDate = undefined,
      endDate = undefined,
      memberExclusive = false,
    }) {
      if (!startDate || !endDate) return;

      const start = toSGTEpoch(startDate);
      const end = toSGTEpoch(endDate);

      let accessInterval = setInterval(check, 60 * 1000);

      function check() {
        const nowInSGT = toSGTEpoch(new Date());
        // check if event already passed the end date then display everything
        if (nowInSGT > end) {
          renderBuyActions();
          clearInterval(accessInterval);
        }

        if (nowInSGT >= start && nowInSGT <= end) {
          // if product variant is not member exclusive show buy/cart action
          if (memberExclusive) {
            // if user is logged in display actions
            if (window?.shopifyUser?.id) {
              renderBuyActions();
              toggleStickySideFabVisibility(true);
            } else {
              renderMemberExclusiveActions();
              toggleStickySideFabVisibility(false);
            }
          } else {
            renderBuyActions();
          }

          clearInterval(accessInterval);
        }
      }

      check();
    },
    toggleStickySideFabVisibility: toggleStickySideFabVisibility,
    init: function () {
      document.addEventListener('DOMContentLoaded', () => {
        const productInfoEl = document.querySelector('.product__item-js');

        if (productInfoEl) {
          const earlyAccessStartDate =
            productInfoEl.dataset.memberEarlyAccessStartDate;
          const earlyAccessEndDate =
            productInfoEl.dataset.memberEarlyAccessEndDate;

          const memberExclusive =
            productInfoEl.dataset.memberExclusive === 'true';

          this.observeExclusiveAccess({
            startDate: new Date(earlyAccessStartDate),
            endDate: new Date(earlyAccessEndDate),
            memberExclusive,
          });

          checkActionElementRendering();
        }
      });
      document.addEventListener('resize', checkActionElementRendering);
    },
  };
})();
VariantController.init();
